import * as angular from 'angular';
import * as _ from 'lodash';
import {CheckList, CheckListCommon} from "../../models/checkLists/checkListOverride.module";
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import CheckListsServiceName, {CheckListsService} from "../../services/checkLists/checkLists.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import template from './copyCheckList.tpl.html';
let requires = [CheckListsServiceName, LoaderServiceName, NotifyServiceName, NewGuidServiceName, AuthDataServiceName];

export interface CopyCheckListControllerData {
  originalCheckList: CheckList;
  plants: Plant[];
}

interface CopyCheckListController {
  copyCheckListForm: any;

  plants: Plant[];
  shops: apsViewModels.ShopNavigation[];
  shops_filtered(): apsViewModels.ShopNavigation[];

  id: string;
  originalCheckList: CheckList;
  name: string;
  plant: Plant;
  shop: apsViewModels.ShopNavigation;

  submit(): void;
  cancel(): void;
}

export function openCopyCheckList(data: CopyCheckListControllerData,
                                  $modal: mm.foundation.modal): angular.IPromise<apsCommands.CopyCheckList> {
  return $modal.open({
    template: template,
    controller: 'CopyCheckListCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

export default angular.module('aps.controller.copyCheckList', requires)
  .controller('CopyCheckListCtrl', copyCheckListCtrl)
  .name;

function copyCheckListCtrl(
  $modalInstance: mm.foundation.modalInstance,
  data: CopyCheckListControllerData,
  checkListsService: CheckListsService,
  loaderService: LoaderService,
  notifyService: NotifyService,
  newGuidService: NewGuidService,
  authDataService: AuthDataService) {
  'use strict';

  var vm = <CopyCheckListController>this;

  var isAdmin = authDataService.isAdmin();

  vm.originalCheckList = data.originalCheckList;
  vm.name = 'Copy of ' + vm.originalCheckList.name;

  var shopsAllSelection = CheckListCommon.getAllShopsItem();
  var plantsAllSelection = CheckListCommon.getAllPlantsItem();

  if (isAdmin) {
    vm.plants = data.plants;
    vm.plant = plantsAllSelection;
  } else {
    vm.plants = _.filter(data.plants, (plant) => authDataService.isPlantAdmin(plant.id));
    vm.plant = vm.plants[0];
  }

  vm.shop = shopsAllSelection;

  newGuidService.getNewGuid('checkList').then(id => vm.id = id);

  vm.submit = () => {

    if (vm.copyCheckListForm.$invalid) {
      return;
    }

    var plant = vm.plant !== plantsAllSelection ? vm.plant : undefined;
    var shop = vm.shop !== shopsAllSelection ? vm.shop : undefined;

    var command: apsCommands.CopyCheckList = {
      id: vm.id,
      originalCheckListId: vm.originalCheckList.id,
      name: vm.name,
      plantId: plant ? plant.id : null,
      shopId: shop ? shop.id : null
    };

    var promise = checkListsService.copyCheckList(command).then(() => {
      var checkList: apsViewModels.CheckListSummary = {
        id: vm.id,
        name: vm.name,
        department: vm.originalCheckList.department,
        pasType: vm.originalCheckList.pasType,
        topNumber: vm.originalCheckList.topNumber,
        plantId: plant ? plant.id : null,
        shopId: shop ? shop.id : null,
        locationType: vm.originalCheckList.locationType,
        locationId: vm.originalCheckList.locationId,
        wareClassId: vm.originalCheckList.wareClassId,
        isGroup: false,
        checkListGroupId: null,
        overrides: [],
        createdOn: new Date(),
        isDeleted: false,
        deletedOn: null
      };
      $modalInstance.close(checkList);
    }, notifyService.handleApiErrors);

    loaderService.loadingPromise(promise);
  };

  vm.cancel = () => {
    $modalInstance.close();
  };

  vm.shops_filtered = () => {
    var result = <apsViewModels.ShopNavigation[]>vm.plant.shops.concat([]);
    if (result.length === 0 || result[0] !== shopsAllSelection) {
      result.unshift(shopsAllSelection);
    }

    if (result.length === 1) {
      vm.shop = result[0];
    }

    return result;
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/checkLists/copyCheckList.controller.ts